import { JSX } from 'react'

import { IconProps } from '../../icon'

const Like: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.1506 22.6037C38.3074 21.4199 36.9777 20.7551 35.5345 20.7551H32.4372C32.2751 20.7551 32.1616 20.6578 32.1129 20.6091C32.0643 20.5443 31.9994 20.447 32.0318 20.3172C32.3399 18.4686 32.1291 16.6362 31.4156 14.9984C30.2805 12.3715 28.1887 10.9769 26.6482 10.2634C25.7563 9.85803 24.7347 9.92289 23.9077 10.4418C23.0969 10.9607 22.5942 11.8526 22.5942 12.8255V17.1065C22.5942 19.1173 20.9564 20.7551 18.9457 20.7551H12.4594C9.99455 20.7551 8 22.7496 8 25.2144V33.3223C8 35.7871 9.99455 37.7817 12.4594 37.7817H32.8264C34.7561 37.7817 36.4426 36.5493 37.0588 34.7331L39.7668 26.6252C40.2208 25.2468 40.01 23.7874 39.1506 22.6037ZM10.4324 33.3223V25.2144C10.4324 24.0955 11.3405 23.1874 12.4594 23.1874H16.1079V35.3493H12.4594C11.3405 35.3493 10.4324 34.4412 10.4324 33.3223ZM37.4479 25.863L34.7399 33.971C34.4642 34.798 33.6859 35.3493 32.8102 35.3493H18.5403V23.1874H18.9457C22.3024 23.1874 25.0266 20.4632 25.0266 17.1065V12.8255C25.0266 12.6471 25.1239 12.5336 25.205 12.485C25.2698 12.4363 25.432 12.3715 25.6104 12.4688C26.7779 13.0039 28.3346 14.0579 29.1779 15.9714C29.713 17.1876 29.8589 18.5173 29.6157 19.9118C29.486 20.7226 29.6968 21.5496 30.2319 22.1821C30.767 22.8307 31.5616 23.1874 32.4048 23.1874H35.502C36.1669 23.1874 36.7669 23.4955 37.1398 24.0307C37.529 24.5658 37.6263 25.2306 37.4155 25.863H37.4479Z'
      fill='black'
    />
  </svg>
)

export default Like
